// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
// Add any other Firebase services you want to use

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDeQj18KyuuUVki9qB_UxYYAek4aaIo3ag",
  authDomain: "vybecode-36007.firebaseapp.com",
  projectId: "vybecode-36007",
  storageBucket: "vybecode-36007.firebasestorage.app",
  messagingSenderId: "912522611655",
  appId: "1:912522611655:web:2879ad90252fbc322967e2",
  measurementId: "G-K8EKJ8QV1E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { app, analytics, db, auth, storage };
export default app; 